import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2df842ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "global-search-menu" }

import { ref } from "vue";
import { TopicName } from "@/components/common/globalSearch/constants";

/** components */
import MenuFilter from "@/components/common/globalSearch/menuSearch/menuFilter.vue";
import MenuTopic from "@/components/common/globalSearch/menuSearch/menuTopic.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isShow: { type: Boolean },
    searchKey: {},
    searching: {}
  },
  emits: ["close-menu", "update-search-key"],
  setup(__props: any, { emit }) {

const props = __props;





const updateSearchKey = (value: any) => {
  emit("update-search-key", value);
};

const selectedFilterIds = ref([TopicName.all]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "tw-fixed tw-top-[56px] tw-w-full tw-h-screen tw-z-[9998] tw-left-0 tw-bg-[rgba(0,0,0,0.5)]",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close-menu')), ["stop"]))
    }, null, 512), [
      [_vShow, _ctx.isShow]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(MenuTopic, {
        "selected-filter-ids": selectedFilterIds.value,
        "search-key": _ctx.searchKey,
        searching: _ctx.searching,
        onCloseMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-menu'))),
        onOnSelect: updateSearchKey
      }, null, 8, ["selected-filter-ids", "search-key", "searching"]),
      _createVNode(MenuFilter, {
        "selected-filter-ids": selectedFilterIds.value,
        onOnSelect: _cache[2] || (_cache[2] = ($event: any) => (selectedFilterIds.value = $event))
      }, null, 8, ["selected-filter-ids"])
    ], 512), [
      [_vShow, _ctx.isShow]
    ])
  ], 64))
}
}

})